export const GEORGIAN_MOBILE_PREFIXES = [
  '511',
  '514',
  '515',
  '555',
  '557',
  '558',
  '568',
  '570',
  '571',
  '574',
  '577',
  '579',
  '591',
  '592',
  '593',
  '595',
  '596',
  '597',
  '598',
  '599',
];

export const getPhoneDigits = (value) => String(value || '').replace(/\D/g, '');

export const formatGeorgianPhone = (value) => {
  const digits = getPhoneDigits(value).slice(0, 9);
  const parts = [
    digits.slice(0, 3),
    digits.slice(3, 5),
    digits.slice(5, 7),
    digits.slice(7, 9),
  ].filter(Boolean);

  return parts.join(' ');
};

export const isValidGeorgianMobile = (value) => {
  const digits = getPhoneDigits(value);

  return digits.length === 9 && GEORGIAN_MOBILE_PREFIXES.some((prefix) => digits.startsWith(prefix));
};
